
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-datetime-config-view',
  standalone: true,
  templateUrl: './datetime-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatetimeConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
